module.exports = __webpack_public_path__ + "img/ev_charger_power_off.69bfb944.png";